<div
    id="app-portal"
    class="app"
    [ngClass]="{
        'header-dark': themeDark,
        'side-nav-dark': themeDark,
        'sidebar-opened': sidenavOpened,
        'is-opened': app.layout.isMenuOpened,
        rtl: app.layout.rtlActived,
        embedded: isEmbedded,
        'no-portal-header': !portalHeader
    }"
>
    <div class="layout" [ngClass]="headerSelected">
        <div [ngClass]="sidenavSelected">
            <in-sidenav
                *ngIf="portalHeader"
                (toggleMenu)="sidemenuToggle(overlayDiv)"
            ></in-sidenav>

            <div
                #overlayDiv
                [ngClass]="{
                    hidden: !isMobile
                }"
                (click)="sidemenuToggle(overlayDiv)"
                class="page-container overlay"
            ></div>

            <div class="page-container">
                <in-portal-header
                    *ngIf="portalHeader"
                    (toggleMenu)="sidemenuToggle(overlayDiv)"
                ></in-portal-header>

                <div class="main-content">
                    <router-outlet></router-outlet>
                </div>

                <div
                    *ngIf="notification_Active"
                    id="notification"
                    class="checkin"
                >
                    <h2 *ngIf="notification_Title">
                        {{ notification_Title | translate }}
                        <span class="{{ statusObject[notification_Status] }}">
                            <mat-icon>
                                {{
                                    notification_Status === 'authorizedAccess'
                                        ? 'check_circle'
                                        : 'sms_failed'
                                }}
                            </mat-icon>
                        </span>
                    </h2>

                    <button
                        class="tright"
                        (click)="notificationClose($event)"
                        circlebutton
                        mat-button
                    >
                        <mat-icon>close</mat-icon>
                    </button>

                    <div *ngIf="notification_User">
                        <a
                            *ngIf="notification_idClient"
                            href="{{ portal }}/clients/client/{{
                                notification_idClient
                            }}"
                            class="user"
                        >
                            {{ notification_User }}
                        </a>
                        <span *ngIf="!notification_idClient" class="user">
                            {{ notification_User }}
                        </span>
                    </div>

                    <div *ngIf="notification_Message">
                        <b class="{{ statusObject[notification_Status] }}">
                            {{ notification_Message }}
                        </b>
                    </div>

                    <div *ngIf="notification_Balance">
                        {{
                            'layout.portal-layout.balance'
                                | translate: { user: notification_User }
                        }}
                        <b>
                            <span
                                class="{{ checkBalance(notification_Balance) }}"
                            >
                                {{ notification_Balance }}{{ currency }}
                            </span>
                        </b>
                    </div>

                    <div *ngIf="notification_Membership">
                        <span>
                            {{ 'layout.portal-layout.membership' | translate }}
                            <span
                                class="{{
                                    checkMembership(notification_Membership)
                                }}"
                            >
                                {{
                                    notification_Membership.membershipName
                                }} </span
                            >,
                            {{
                                notification_Membership.isExpired
                                    ? ('layout.portal-layout.expired'
                                      | translate)
                                    : ('layout.portal-layout.expires-at'
                                      | translate
                                          : {
                                                date: notification_Membership.expiryDate
                                            })
                            }}
                        </span>
                    </div>

                    <div
                        *ngIf="
                            !notification_Membership &&
                            notification_customerMemberships.length >= 1
                        "
                    >
                        <span>
                            <span
                                class="{{
                                    checkMembership(
                                        notification_customerMemberships[0]
                                    )
                                }}"
                            >
                                {{
                                    'layout.portal-layout.last-expired-membership'
                                        | translate
                                            : {
                                                  membershipName:
                                                      notification_customerMemberships[0]
                                                          .membershipName
                                              }
                                }} </span
                            >,
                            {{
                                'layout.portal-layout.expired-at'
                                    | translate
                                        : {
                                              date: notification_customerMemberships[0]
                                                  .expiryDate
                                          }
                            }}
                        </span>
                    </div>

                    <div *ngIf="notification_Time">
                        <span class="time">{{ notification_Time }}</span>
                    </div>
                </div>

                <div *ngIf="portalFooter">
                    <in-portal-footer></in-portal-footer>
                </div>
            </div>
        </div>
    </div>
</div>
